import { I18N } from 'aurelia-i18n';
import { StringHelper } from '../Helpers/StringHelper';
import { ValidateResult } from 'aurelia-validation';
import { ObjectHelper } from '../Helpers/ObjectHelper';

declare var Bs5Utils;

export class Toastr {
  static inject = [I18N];
  private static _i18n: I18N = new I18N();
  private static bs5Utils: any = null;

  private static _toastrOptionNormal: Object = {
    progressBar: true,
    closeButton: true,
    positionClass: "toast-bottom-right",
    showDuration: 300,
    hideDuration: 500,
    timeOut: 3000
  }
  private static _toastrOptionError: Object = {
    progressBar: true,
    closeButton: true,
    positionClass: "toast-bottom-right",
    showDuration: 300,
    hideDuration: 500,
    timeOut: 0
  }

  private static Init() {
    //https://www.npmjs.com/package/bs5-utils#api
    //console.log(51, 'Init', this.bs5Utils);
    if (this.bs5Utils == null) {
      Bs5Utils.defaults.toasts.position = 'bottom-right';
      Bs5Utils.defaults.toasts.container = 'toast-container';
      Bs5Utils.defaults.toasts.stacking = false;
      this.bs5Utils = new Bs5Utils();
      //console.log(88888, 'success', this.bs5Utils);
    }

  }
  public static NewInfoWindow(title: string, htmlBody: string, cssClass: string): JQuery {
    let option1 = {
      progressBar: true,
      closeButton: true,
      positionClass: "toast-bottom-right",
      showDuration: 300,
      hideDuration: 500,
      tapToDismiss: false,
      closeOnHover: false,
      timeOut: 0,
      extendedTimeOut: 0,
      toastClass: 'toast ' + cssClass
    };

    return toastr.info(htmlBody, title, option1);
  }

  public static Info(title: string, message: string, stickyEnabled: boolean = false, timeout: number = 5000) {
    let option1 = {
      progressBar: true,
      closeButton: true,
      positionClass: "toast-bottom-right",
      showDuration: 300,
      hideDuration: 500,
      timeOut: timeout,
      extendedTimeOut: 1000
    };
    if (stickyEnabled) {
      option1.timeOut = 0;
      option1.extendedTimeOut = 0;
    }

    toastr.info(this._i18n.tr(message), this._i18n.tr(title), option1);
  }

  public static Success(title: string, message: string, stickyEnabled: boolean = false, timeout: number = 5000) {
    this.Init();
    this.bs5Utils.Snack.show('success', this._i18n.tr(title), timeout, true);
  }

  public static Warning(title: string, message: string, messageTranslate: boolean = true, timeout: number = 10000) {
    this.Init();
    this.bs5Utils.Snack.show('warning', this._i18n.tr(title), timeout, true);
  }

  public static Error(title: string, message: string, messageTranslate: boolean = true) {
    this.Init();
    this.bs5Utils.Snack.show('danger', this._i18n.tr(title), 60000, true);
  }

  public static ErrorSimple(title: string) {
    this.Init();
    this.bs5Utils.Snack.show('danger', this._i18n.tr(title), 60000, true);
  }

  public static ValidateError(validateResult: Array<ValidateResult>) {
    let message: string = '';
    if (ObjectHelper.ArrayIs(validateResult)) {
      for (let i1 = 0; i1 < validateResult.length; i1++) {
        message = message + validateResult[i1] + '<br />';
      }
    }
    toastr.error(this._i18n.tr(message), this._i18n.tr('Toastr.ThisFormIsNotValid'), this._toastrOptionError);
  }

}


